export default __webpack_public_path__ + "static/art-innovation-1ae80dc2260c3268aed63f676c9f1587.webp";